import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getPartners = (): Promise<ISelectModel<number>[]> => {
  return API.get('/api/root/partners/all').then(res => res?.data);
};
